import ActionNotification from "../components/core/ActionNotification/ActionNotification";

/**
 * Handles double clicking. Shows an alert if single clicked.
 */
export class DoubleClickHandler {
  static readonly delay: number = 500;

  private lastClickedAt: Date | null = null;
  private alertTimeoutId: any = null;

  constructor(public message: string | null) {

  }

  /**
   * Aborts the delayed single click action.
   */
  abort() {
    clearTimeout(this.alertTimeoutId);
  }

  /**
   * @returns Whether the click was a double click.
   */
  click(onSingleClick?: () => void): boolean {
    this.abort();

    const timeSinceLastClick = Date.now() - this.lastClickedAt?.getTime();
    this.lastClickedAt = new Date();

    const isDouble = timeSinceLastClick <= DoubleClickHandler.delay;

    if (!isDouble) {
      this.alertTimeoutId = setTimeout(() => {
        onSingleClick?.();

        if (this.message) {
          ActionNotification.show(this.message);
        }
      }, DoubleClickHandler.delay);
    }

    return isDouble;
  }
}

export class DoubleKeyPressHandler extends DoubleClickHandler {
  //  TODO: Visa i meddelandet vilken tangent som orsakade det. En liten symbol i början.
}